/**
 * Mapea los datos de un producto desde el formato recibido por el Backend al formato y orden
 * exacto requerido por el componente Table de la UI según el tipo de vista.
 *
 * @param {Object} product - Objeto de producto crudo del backend.
 * @param {string} type - Tipo de tabla ('stock', 'sell', 'buy').
 * @returns {Object} Producto mapeado con el orden de llaves alineado a las columnas visuales.
 */
export const mapProductForTable = (product, type) => {
    if (!product) return product;

    const mapped = {};

    // Definir las llaves y el orden estricto según la vista de la tabla
    if (type === 'stock') {
        mapped.sku = product.sku;
        mapped.name = product.name;
        mapped.value = product.value;
        mapped.buy_value = product.buy_value;
        mapped.stock = product.stock;
        mapped.warranty = product.warranty || 'Sin Garantía';
        mapped.has_tax = product.sell_tax ? (product.sell_tax.value > 0) : false;
        mapped.enable = product.enable;
    } else if (type === 'sell') {
        mapped.sku = product.sku;
        mapped.name = product.name;
        mapped.value = product.value;
    } else if (type === 'buy') {
        mapped.sku = product.sku;
        mapped.name = product.name;
        mapped.buy_value = product.buy_value;
    }

    // Copiar el resto de las propiedades del backend (para mantenerlas disponibles en modales/acciones)
    // sin alterar el orden de inserción de las llaves principales.
    Object.keys(product).forEach((key) => {
        if (!(key in mapped)) {
            mapped[key] = product[key];
        }
    });

    return mapped;
};

/**
 * Mapea una lista de productos utilizando el mapeador individual.
 *
 * @param {Array} products - Lista de productos crudos.
 * @param {string} type - Tipo de tabla.
 * @returns {Array} Lista de productos ordenados y listos para la visualización.
 */
export const mapProductsListForTable = (products, type) => {
    if (!Array.isArray(products)) return [];
    return products.map(product => mapProductForTable(product, type));
};
